import { render, staticRenderFns } from "./FooterResponsive.vue?vue&type=template&id=d1259ef6&scoped=true&"
import script from "./FooterResponsive.vue?vue&type=script&lang=js&"
export * from "./FooterResponsive.vue?vue&type=script&lang=js&"
import style0 from "./FooterResponsive.vue?vue&type=style&index=0&id=d1259ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1259ef6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
